import React from "react";
import { reviewCreditCopy } from "../copy/reviewCreditCopy";
import ReviewCreditPurchase from "./ReviewCreditPurchase";

export default function ReviewBalanceCard({
  credits,
  packages = [],
  canPurchase = false,
  notice = "",
}) {
  const billing = Boolean(credits?.billingEnabled);
  const amount = billing ? Number(credits?.available || 0) : null;

  return (
    <section className="rr-panel-card rr-balance" id="review-balance" aria-labelledby="balance-title">
      <h2 id="balance-title">Review balance</h2>
      {notice ? <p className="rr-balance-notice">{notice}</p> : null}
      {!credits ? <p>Review balance is unavailable right now. The rest of the workspace is ready.</p> : billing ? (
        <>
          <p className="rr-balance-value">{amount} <span>{amount === 1 ? "review" : "reviews"}</span></p>
          <p>$1 per completed review</p>
          <p className="rr-balance-trust">
            Previewing is free. Reviewing the same commit again does not spend another credit.
            {credits.reserved > 0 ? ` ${credits.reserved} ${credits.reserved === 1 ? "review is" : "reviews are"} reserved.` : ""}
            {" "}A review that cannot be judged because product context is missing does not spend a credit.
          </p>
          {credits.purchasesEnabled ? (
            <ReviewCreditPurchase packages={packages} canPurchase={canPurchase} purchasesEnabled />
          ) : <p>{reviewCreditCopy}</p>}
        </>
      ) : (
        <>
          <p className="rr-balance-value">Pilot</p>
          <p>{reviewCreditCopy}</p>
        </>
      )}
    </section>
  );
}
